import { Recording } from '@app/routes/content/domain';
import {
  buildTitleFromDate,
  getDefaultThumbnailUrl,
} from '@app/routes/content/utils';
import { useAppSelector } from '@app/store';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useRecordingAnalytics } from '../../../hooks';
import { selectRecording } from '../../../selector';
import { SectionCard } from './section-card';

export const ParentVideo = () => {
  const { t } = useTranslation();
  const { trackRecordingEvent } = useRecordingAnalytics();
  const navigate = useNavigate();
  const location = useLocation();
  const recording = useAppSelector(selectRecording) as Recording;
  const { parent } = recording || {};
  const { id, title, started_at, thumbnail } = parent || {};
  const defaultThumbnailUrl = getDefaultThumbnailUrl();
  const displayTitle =
    title ||
    buildTitleFromDate({
      locale: 'en',
      title: title || '',
      startedAt: started_at || '',
    });

  const handleParentVideoClick = useCallback(() => {
    trackRecordingEvent('ch_recording_editor_parent_video_clicked');
    const url = `../../${id}/editor`;
    const currentFullUrl = window.location.origin + location.pathname;
    const finalUrl = `${url}?backUrl=${encodeURIComponent(currentFullUrl)}`;
    navigate(finalUrl);
  }, [id, navigate, trackRecordingEvent, location.pathname]);

  if (!parent) {
    return null;
  }

  return (
    <SectionCard className="bg-spring-neutral-base p-3">
      <div className="flex flex-col gap-3">
        <p className="text-white text-sm font-medium m-0">
          {t('content-recording.content-menu.parent-video')}
        </p>
        <button
          className="flex items-center gap-2 w-full"
          onClick={handleParentVideoClick}
          title={displayTitle}
          data-testid="parent-video-navigation-button"
        >
          <img
            className="h-6 w-auto rounded-[.25rem] object-contain"
            src={thumbnail || defaultThumbnailUrl}
            alt={displayTitle}
          />
          <p className="text-white text-xs font-medium m-0 flex-1 min-w-0 line-clamp-1 text-left">
            {displayTitle}
          </p>
        </button>
      </div>
    </SectionCard>
  );
};
